import type { EdgeStyle } from '@/domain/funnel/edge-system';

/**
 * SPEC-006 EDGE-REQ-020/EDGE-REQ-021 — animation must respect the OS-level
 * reduced-motion preference regardless of the edge's own `animated` flag.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function strokeDasharrayFor(style: EdgeStyle): string | undefined {
  return style === 'dashed' ? '6 4' : undefined;
}

export const EDGE_COLOR_HEX: Record<string, string> = {
  neutral: '#9aa09b',
  blue: '#2f9bff',
  green: '#2fc87b',
  amber: '#eaa52d',
  violet: '#8666f5',
};

export function edgeColorFor(colorOverride: string | undefined, fallback: string): string {
  return (colorOverride && EDGE_COLOR_HEX[colorOverride]) || fallback;
}
